export default "__VITE_ASSET__TG_k$0OO__ 100w";